export default __webpack_public_path__ + "images/21c2143fe5305b904a67d5158e27edf8-bg-03.jpg";